import React from 'react';

import ReactPlayer from 'react-player';

import { CModal } from './styles';

type ViewVideoModalProps = {
  url: string;
  visible: boolean;
  onCancel: () => void;
};

const ViewVideoModal = ({ url, visible, onCancel }: ViewVideoModalProps) => {
  const [play, setPlay] = React.useState(false);
  const playerRef = React.useRef(null);

  React.useEffect(() => {
    if (visible) {
      setPlay(true);
    }
  }, [visible]);

  return (
    <CModal
      centered
      destroyOnClose
      visible={visible}
      onCancel={() => {
        setPlay(false);
        onCancel();
      }}
    >
      <ReactPlayer
        ref={playerRef}
        controls
        height="100%"
        playing={play}
        url={url}
        width="100%"
      />
    </CModal>
  );
};

export default ViewVideoModal;
